import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3049e5f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "agent-details w-100",
  style: {"margin-top":"10px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-3 agent-details-cell" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "agent-details-label" }, "Business Name")
], -1))
const _hoisted_4 = { class: "col-lg-3 agent-details-cell" }
const _hoisted_5 = { class: "agent-details-text" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-3 agent-details-cell" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "agent-details-label" }, "Status")
], -1))
const _hoisted_7 = { class: "col-lg-3 agent-details-text" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-3 agent-details-cell" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "agent-details-label" }, "Office Number")
], -1))
const _hoisted_10 = { class: "col-lg-3 agent-details-cell" }
const _hoisted_11 = {
  key: 0,
  class: "agent-details-text"
}
const _hoisted_12 = ["href"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-3 agent-details-cell" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "agent-details-label" }, "Address Line")
], -1))
const _hoisted_14 = { class: "col-lg-3 agent-details-cell" }
const _hoisted_15 = { class: "agent-details-text" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-3 agent-details-cell" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "agent-details-label" }, "Mobile Number")
], -1))
const _hoisted_18 = { class: "col-lg-3 agent-details-cell" }
const _hoisted_19 = {
  key: 0,
  class: "agent-details-text"
}
const _hoisted_20 = ["href"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-3 agent-details-cell" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "agent-details-label" }, "City")
], -1))
const _hoisted_22 = { class: "col-lg-3 agent-details-cell" }
const _hoisted_23 = { class: "agent-details-text" }
const _hoisted_24 = { class: "row" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-3 agent-details-cell" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "agent-details-label" }, "Email")
], -1))
const _hoisted_26 = { class: "col-lg-3 agent-details-cell" }
const _hoisted_27 = ["href"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-3 agent-details-cell" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "agent-details-label" }, "State")
], -1))
const _hoisted_29 = { class: "col-lg-3 agent-details-cell" }
const _hoisted_30 = { class: "agent-details-text" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-3 agent-details-cell" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "agent-details-label" }, "ACN")
], -1))
const _hoisted_33 = { class: "col-lg-3 agent-details-cell" }
const _hoisted_34 = { class: "agent-details-text" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-3 agent-details-cell" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "agent-details-label" }, "Post Code")
], -1))
const _hoisted_36 = { class: "col-lg-3 agent-details-cell" }
const _hoisted_37 = { class: "agent-details-text" }
const _hoisted_38 = { class: "row" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-3 agent-details-cell" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "agent-details-label" }, "ABN")
], -1))
const _hoisted_40 = { class: "col-lg-3 agent-details-text" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-3 agent-details-cell" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "agent-details-label" }, "Country")
], -1))
const _hoisted_42 = { class: "col-lg-3 agent-details-cell" }
const _hoisted_43 = { class: "agent-details-text" }
const _hoisted_44 = { class: "row p-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StatusIndicator = _resolveComponent("StatusIndicator")!
  const _component_AlertDanger = _resolveComponent("AlertDanger")!
  const _component_AlertWarning = _resolveComponent("AlertWarning")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.agency?.business_name), 1)
      ]),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_StatusIndicator, {
          negativeIndicator: _ctx.getStatus.negativeIndicator,
          "text-status": _ctx.getStatus.text,
          modelValue: _ctx.getStatus.value,
          "text-color": _ctx.getStatus.color,
          "text-alignment": `left`
        }, null, 8, ["negativeIndicator", "text-status", "modelValue", "text-color"])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        (!_ctx.agency?.business_mobile_number)
          ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.agency?.business_mobile_number || 'Not Specified'), 1))
          : (_openBlock(), _createElementBlock("a", {
              key: 1,
              href: `tel:${_ctx.unformattedMobileNumber}`,
              class: "agent-details-text"
            }, _toDisplayString(_ctx.agency?.business_mobile_number || 'Not Specified'), 9, _hoisted_12))
      ]),
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.agency?.address_line), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _hoisted_17,
      _createElementVNode("div", _hoisted_18, [
        (!_ctx.agency?.business_mobile_number)
          ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.agency?.business_mobile_number || 'Not Specified'), 1))
          : (_openBlock(), _createElementBlock("a", {
              key: 1,
              href: `tel:${_ctx.unformattedMobileNumber}`,
              class: "agent-details-text"
            }, _toDisplayString(_ctx.agency?.business_mobile_number || 'Not Specified'), 9, _hoisted_20))
      ]),
      _hoisted_21,
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.agency?.city), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _hoisted_25,
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("a", {
          href: `mailto: ${_ctx.agency?.business_email_address}`,
          class: "agent-details-text"
        }, _toDisplayString(_ctx.agency?.business_email_address), 9, _hoisted_27)
      ]),
      _hoisted_28,
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.agency?.state), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_31, [
      _hoisted_32,
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.formattedACN), 1)
      ]),
      _hoisted_35,
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.agency?.post_code), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_38, [
      _hoisted_39,
      _createElementVNode("div", _hoisted_40, [
        _createVNode(_component_StatusIndicator, {
          negativeIndicator: `bi bi-x-circle`,
          modelValue: _ctx.abnStatus.value,
          "text-status": _ctx.formattedABN,
          "text-color": _ctx.abnStatus.color,
          "text-alignment": `left`
        }, null, 8, ["modelValue", "text-status", "text-color"])
      ]),
      _hoisted_41,
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.agency?.country), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_44, [
      (_ctx.agency.business_status === 'deleted')
        ? (_openBlock(), _createBlock(_component_AlertDanger, {
            key: 0,
            "alert-title": `Agency has been deleted.`,
            "alert-description": _ctx.agency.deleted_remarks,
            "alert-time": _ctx.formattedDate(_ctx.agency.deleted_at),
            "alert-user": 
          _ctx.makeCapital(
            `${_ctx.agency.deleted.first_name} ${_ctx.agency.deleted.last_name}`
          )
        
          }, null, 8, ["alert-title", "alert-description", "alert-time", "alert-user"]))
        : _createCommentVNode("", true),
      (_ctx.agency.business_status === 'suspended')
        ? (_openBlock(), _createBlock(_component_AlertWarning, {
            key: 1,
            "alert-title": `Agency has been suspended.`,
            "alert-description": _ctx.agency.suspend_remarks,
            "alert-time": _ctx.formattedDate(_ctx.agency.suspend_date),
            "alert-user": 
          _ctx.makeCapital(
            `${_ctx.agency.suspended.first_name} ${_ctx.agency.suspended.last_name}`
          )
        
          }, null, 8, ["alert-title", "alert-description", "alert-time", "alert-user"]))
        : _createCommentVNode("", true)
    ])
  ]))
}